<template>
  <div class="status-action">
    <DocStatus
      v-if="product.docNeeded"
      :product="product"
    />
    <PassiveBrand v-else-if="product.isPassiveBrand" />
    <div v-else-if="isLockedProduct">
      <div>
        <LockReason
          v-if="product.lockReason === null || product.lockReason === false"
          :product="product"
        />
      </div>
      <SaleStatusLabel :on-sale="product.onSale" />
      <div>
        {{ getProductLockReason }}
      </div>
      <div>
        Kilit kaldırma işlemi için partner.trendyol.com'u kullanınız.
      </div>
    </div>
    <Blacklisted
      v-else-if="product.blacklisted"
      :product="product"
    />
    <RejectReason
      v-else-if="product.rejectReasons.length"
      :product="product"
    />
    <RejectReasonDetail
      v-else-if="product.rejectReasonDetails.length"
      :product="product"
    />
    <div v-else-if="!hasImage && !isOnsale">
      <div>
        Ürünün görseli eksik veya hatalıdır.
        Ürün görselini yüklediğinizde kontrol süreci başlayacaktır.
      </div>
    </div>
    <span v-else-if="product.needProductPrice">
      {{ $t('product.needProductPrice') }}
    </span>
    <span v-else-if="product.needProductStock">
      {{ $t('product.needProductStock') }}
    </span>
    <span v-else-if="product.waitingForContent">
      {{ $t('product.waitingForContent') }}
    </span>
    <span v-else-if="statusFilter(product.updateApproveStatus)">
      {{ statusFilter(product.updateApproveStatus) }}
    </span>
    <span v-else>
      İçerik Onayı Bekliyor
    </span>
  </div>
</template>

<script>
import PassiveBrand from './Components/PassiveBrand';
import RejectReason from './Components/RejectReason';
import RejectReasonDetail from './Components/RejectReasonDetail';
import Blacklisted from './Components/Blacklisted';
import SaleStatusLabel from './Components/SaleStatusLabel';
import DocStatus from './Components/DocStatus';
import LockReason from './Components/LockReason';

export default {
  name: 'StatusAction',
  components: {
    LockReason,
    DocStatus,
    SaleStatusLabel,
    PassiveBrand,
    Blacklisted,
    RejectReasonDetail,
    RejectReason,
  },
  props: {
    product: {
      type: Object,
      default: () => ({
        approved: false,
      }),
    },
  },
  computed: {
    isBlackListReasonDiffPrice () {
      return String(this.product.blacklistReason).trim() === 'Farklı adet/ebat ürün satışı';
    },
    hasImage () {
      return this.product?.images?.length > 0;
    },
    isOnsale () {
      return this.product?.onSale;
    },
    getProductLockReason () {
      return this.$t(`product.lockReason.${this.product.lockReason}`) || '';
    },
    isLockedProduct () {
      return (this.product.lockReason && this.product.lockReason.length > 0);
    },
  },
  methods: {
    statusFilter (status) {
      if (!status || status === '') {
        return false;
      }

      return this.$t(`product.approvalStatus.${status}`);
    },
    onSuccess () {
      this.$emit('onSuccess');
    },
  },
};
</script>
